import { render, staticRenderFns } from "./ProspectCreateFast.vue?vue&type=template&id=2b23e5c6"
import script from "./ProspectCreateFast.vue?vue&type=script&lang=ts"
export * from "./ProspectCreateFast.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports